import { WitcoPlatform } from "../../models/WitcoPlatform";

const cincPlatformStore = ({
    namespaced: true,
    state : {},
    actions: {
        async getPlatforms({commit, state, rootState, rootGetters} : {commit:any, state:any, rootState: any, rootGetters :any}, search : string) {
            return await rootGetters.facebookMarketingFactory.GetCincPlatforms(search);
        },
        async getPlatform({commit, state, rootState, rootGetters} : {commit:any, state:any, rootState: any, rootGetters :any}, id : string) {
            return await rootGetters.facebookMarketingFactory.GetCincPlatform(id);
        }
    },
    mutations: {
        setCincPlatforms(state: any, cincPlatforms: WitcoPlatform[]){
            state.cincPlatforms = cincPlatforms;
        }
    }
});
export default cincPlatformStore;